
import { api } from '../shared/api';
import { handleFilterParams } from '../utils/global';


export const deleteStudentMaterial = async (id: number) => {
  const { data: response }: any = await api.delete(`studentMaterials/${id}`);
  return response.data;
};
